import React from 'react';
import {FormPostDemand} from './sub-view/post-demand';
import {UserLayout} from 'components/layouts/user';

class PostDemand extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <UserLayout active='post-demand'>
        <h1 className="user-header">Gửi kết nối cung cầu</h1>
        <FormPostDemand contentDemandFromProduct={this.props.contentDemandFromProduct}/>
      </UserLayout>
    );
  }
}

export default PostDemand;



// WEBPACK FOOTER //
// ./components/users/PostDemand.jsx